/* @flow */


import globalParams from '../globalparams';
import adconfig from '../adconfig';
import { isOptedOut } from './privacyutils';
import { isFunction, isObject } from './coreutils';

/**
 * Returns filtered Custom Vars if user has opted out (CCPA, DNT, or User ID opt-out)
 *
 * @param {window} w - window object
 * @param {boolean} bSkipOptout - Skip opt-out check if true
 *
 * @returns {object} - Custom Vars
 */
export default function getCVars(
  w: WindowProxy = null,
  bSkipOptout: boolean = false
): anyObject {
  const gParams = globalParams.get();
  let cVars: CustomVars = gParams.customVars || {};
  const { settings } = adconfig.get();
  const { cvFilter } = settings;

  if (isFunction(cVars)) {
    // Let's pass page name to this function to get custom var
    cVars = cVars.call(w, adconfig.getPageName());
  }

  if (!isObject(cVars)) {
    // data sanitization
    cVars = {};
  }

  const lCVars = {};

  const doFilter =
    !bSkipOptout && isOptedOut() && cvFilter && cvFilter.length > 0;

  /* Create a copy of custom vars to avoid modifying/returning reference */
  Object.entries(cVars).forEach(([k, v]) => {
    /* Filter only if user has opted out (CCPA, DNT, or User ID opt-out) and cvFilter has atleast one value */
    if (!doFilter || !cvFilter.includes(k)) {
      lCVars[k] = v;
    }
  });

  return lCVars;
}
